import { Component, Output, EventEmitter, Input } from '@angular/core';
import { TranslocoService, TranslocoPipe } from '@jsverse/transloco';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { RegisterService } from 'app/services/register.service';
import { DialogUtilsService } from 'app/modules/utils/dialog-utility.service';

@Component({
  selector: 'app-terms-step',
  templateUrl: './terms-step.component.html',
  styleUrls: ['./terms-step.component.scss'],
  imports: [
    TranslocoPipe,
    ],
})
export class TermsStepComponent {
  @Output() back = new EventEmitter<void>();
  
  termsContent: SafeHtml = '';
  constructor(
    private _dialogRef: MatDialogRef<TermsStepComponent>,
    private sanitizer: DomSanitizer,
    private registerService: RegisterService,
    private dialogUtilsService: DialogUtilsService
  ) {}
  ngOnInit(): void {
    const cachedTerms = localStorage.getItem('ferrer_terms');
    const cachedTimestamp = localStorage.getItem('ferrer_terms_timestamp');

    const now = new Date().getTime();
    const expirationTime = 24 * 60 * 60 * 1000;

    if (cachedTerms && cachedTimestamp && now - parseInt(cachedTimestamp, 10) < expirationTime) {
      this.termsContent = this.sanitizer.bypassSecurityTrustHtml(cachedTerms);
    } else {
      this.registerService.getTerms().subscribe((termsContent) => {
        this.termsContent = this.sanitizer.bypassSecurityTrustHtml(termsContent);
        localStorage.setItem('ferrer_terms', termsContent);
        localStorage.setItem('ferrer_terms_timestamp', now.toString());
      });
    }
  }

  goBack() {
    this.back.emit();
  }

  shouldShowCloseButton(): boolean {
    const apiVersion = JSON.parse(localStorage.getItem('ferrerSessionData'));
    return this.dialogUtilsService.shouldShowCloseButton();
  }
}